import { SimpleForm, useRecordContext } from 'react-admin';
import { transformWorkerDetails } from '@/pages/Candidate/utils';
import { CreateStyled } from '@/styles/overrides';
import FormContent from './FormContent';
import { RequestMVRProps } from './types';

const RequestMVR = (props: RequestMVRProps) => {
  const record = useRecordContext();

  return (
    <CreateStyled title="Request MVR" {...props}>
      <SimpleForm
        defaultValues={() => transformWorkerDetails(record)}
        mode="onChange"
        reValidateMode="onChange"
        toolbar={false}
      >
        <FormContent {...props} />
      </SimpleForm>
    </CreateStyled>
  );
};

export default RequestMVR;
